<template>
  <div class="application-page">
    <div class="container z-depth-3 white alarm-list-content">
        <h6 class="title">{{ $t('views.alarmlist.railobjects') }}</h6>
        <div class="filter-content">
          <div class="title">{{ $t('views.alarmlist.filter') }}</div>
          <table class="filters">
            <tr>
              <td>{{ $t('views.alarmlist.severity') }}</td>
              <td>
                <label>
                  <input v-model="filter.normal" type="checkbox" checked="checked" />
                  <span>{{ $t('normal') }}</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.warning" type="checkbox" checked="checked" />
                  <span>{{ $t('warning') }}</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.alarm" type="checkbox" checked="checked" />
                  <span>{{ $t('alarm') }}</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.maintenance" type="checkbox" checked="checked" />
                  <span>{{ $t('maintenance') }}</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.unknown" type="checkbox" checked="checked" />
                  <span>{{ $t('unknown') }}</span>
                </label>
              </td>
            </tr>
            <tr>
              <td>{{ $t('views.alarmlist.typeofobject') }}</td>
              <td>
                <label>
                  <input v-model="filter.switch" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.switch') }} (MKW/PSI/SEVT)</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.crossing" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.crossing') }} (OV)</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.axlecounter" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.axlcounter') }} (AT)</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.traindetection" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.traindetection') }} (TR)</span>
                </label>
              </td>
              <td>
                <label>
                  <input v-model="filter.axleshunt" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.axleshunt') }} (SHUNT)</span>
                </label>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                <label>
                  <input v-model="filter.location" type="checkbox" checked="checked" />
                  <span>{{ $t('views.alarmlist.location') }} (RT/TI/T)</span>
                </label>
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
          </table>
        </div>

        <div class="search-content">
          <table class="search">
            <tr>
              <td>{{ $t('views.dashboard.selector.searchrailobjects') }}</td>
              <td colspan="4">
                <div class="search-placeholder z-depth-1">
                  <i class="material-icons left" v-show="!searchLoader">search</i>
                  <i class="material-icons left fa-spin" v-show="searchLoader">autorenew</i>
                  <input id="input_search" type="text" v-bind:placeholder="$t('views.navbar.searchobjects')" v-model="search">
                </div>
              </td>
            </tr>
          </table>
        </div>

        <div class="tab-content">
          <div @click="tab = 'hierarchy'" class="tab clickable" v-bind:class="{'active': tab === 'hierarchy'}">{{ $t('dashboard.hiearchy') }}</div>
          <div class="info">
            <span class="alarm-text"><i class="material-icons">warning</i>{{numberInError}}</span>
            <span class="warning-text"><i class="material-icons">error</i>{{numberInWarning}}</span>
            <span class="maintenance-text"><i class="material-icons">build</i>{{numberInMaintenance}}</span>
          </div>
          <div @click="tab = 'map'" class="tab clickable" v-bind:class="{'active': tab === 'map'}">{{ $t('dashboard.map') }}</div>

          <div class="tab-page" v-bind:class="{'tab-page-fixed': tab === 'map'}">
            <dashboard-map :railObjects="filteredRailObjects" :lastUpdated="lastUpdated" v-if="tab === 'map'"/>
            <ul v-if="tab === 'hierarchy'" v-for="region in regions" v-bind:key="region.RegionId">
              <li v-if="region.shown" @click="region.open = !region.open" class="list-region clickable">
                <i v-if="!region.open" class="material-icons">arrow_right</i>
                <i v-if="region.open" class="material-icons">arrow_drop_down</i>
                {{region.Name}}
                <span v-bind:class="{'extended-opacity': region.open}">
                  <span class="error-count alarm-text">{{region.error.length}}</span><span class="warning-count warning-text">{{region.warning.length}}</span><span class="maintenance-count maintenance-text">{{region.maintenance.length}}</span><span class="total-count">{{region.error.length+region.warning.length+region.maintenance.length+region.normal.length+region.unknown.length}} {{ $t('views.dashboard.selector.railobjects') }}</span>
                </span>
              </li>
              <ul v-if="region.open && department.shown" v-for="department in region.Departments" v-bind:key="department.DepartmentId">
                <li @click="department.open = !department.open" class="list-department clickable">
                  <i v-if="!department.open" class="material-icons">arrow_right</i>
                  <i v-if="department.open" class="material-icons">arrow_drop_down</i>
                  {{department.Name}}
                  <span v-bind:class="{'extended-opacity': department.open}">
                    <span class="error-count alarm-text">{{department.error.length}}</span><span class="warning-count warning-text">{{department.warning.length}}</span><span class="maintenance-count maintenance-text">{{department.maintenance.length}}</span><span class="total-count">{{department.error.length+department.warning.length+department.maintenance.length+department.normal.length+department.unknown.length}} {{ $t('views.dashboard.selector.railobjects') }}</span>
                  </span>
                </li>
                <ul v-if="department.open  && complex.shown" v-for="complex in department.Complexes" v-bind:key="complex.ComplexId">
                  <li @click="complex.open = !complex.open" class="list-complex clickable">
                    <i v-if="!complex.open" class="material-icons">arrow_right</i>
                    <i v-if="complex.open" class="material-icons">arrow_drop_down</i>
                    {{complex.Name}}
                    <span v-bind:class="{'extended-opacity': complex.open}">
                      <span class="error-count alarm-text">{{complex.error.length}}</span><span class="warning-count warning-text">{{complex.warning.length}}</span><span class="maintenance-count maintenance-text">{{complex.maintenance.length}}</span><span class="total-count">{{complex.error.length+complex.warning.length+complex.maintenance.length+complex.normal.length+complex.unknown.length}} {{ $t('views.dashboard.selector.railobjects') }}</span>
                    </span>
                  </li>
                  <ul v-if="complex.open" v-for="railObject in complexRailObjectSorted(complex.RailObjects)" v-bind:key="railObject.RailObjectId">
                    <li v-if="railObject.shown" v-on:click="showDetail(railObject)" class="list-railobject" v-bind:class="{'maintenance-text': railObject.OperationModeId === 5,
                      'warning-text': railObject.OperationModeId !== 5 && railObject.MonitorStatusId === 2,
                      'alarm-text': railObject.OperationModeId !== 5 && railObject.MonitorStatusId === 3,
                      'clickable': (railObject.DataSourceCode === 'WID' ||
                                    railObject.DataSourceCode === 'ATD' ||
                                    railObject.DataSourceCode === 'AKD' ||
                                    railObject.DataSourceCode === 'CDD')}">
                      <i v-if="!complex.open" class="material-icons">arrow_right</i>
                      {{railObject.Name}}
                      <span v-if="railObject.OperationModeId !== 5 && railObject.MonitorStatusId === 2" class="railobject-icon"><i class="material-icons">error</i></span>
                      <span v-if="railObject.OperationModeId !== 5 && railObject.MonitorStatusId === 3" class="railobject-icon"><i class="material-icons">warning</i></span>
                      <span v-if="railObject.OperationModeId === 5" class="railobject-icon"><i class="material-icons">build</i></span>
                      <span v-if="railObject.DataSourceCode === 'WID'" class="railobject-type">{{ $t('views.alarmlist.switch') }}</span>
                      <span v-if="railObject.DataSourceCode === 'OVD'" class="railobject-type">{{ $t('views.alarmlist.crossing') }}</span>
                      <span v-if="railObject.DataSourceCode === 'ATD'" class="railobject-type">{{ $t('views.alarmlist.axlcounter') }}</span>
                      <span v-if="railObject.DataSourceCode === 'AKD'" class="railobject-type">{{ $t('views.alarmlist.axleshunt') }}</span>
                      <span v-if="railObject.DataSourceCode === 'RTD'" class="railobject-type">{{ $t('views.alarmlist.railtemperature') }}</span>
                      <span v-if="railObject.DataSourceCode === 'CDD'" class="railobject-type">{{ $t('views.alarmlist.location') }}</span>
                      <ul v-for="component in railObject.Components" v-bind:key="component.RailObjectId">
                        <li class="list-railobjectComponents">
                          {{ component.Name }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </ul>
              </ul>
            </ul>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Router from '../../router/index'
import UtilitiesService from '../../services/UtilitiesService'
import RailObjectService from '../../services/RailObjectService'
import DepartmentService from '../../services/DepartmentService'
import RegionService from '../../services/RegionService'
import ComplexService from '../../services/ComplexService'
import DashboardMap from '../dashboard/DashboardMap'
import PossObjectCodeService from '@/services/PossObjectCodeService'

var searchTimer = null
var regionsById = {}
var departmentsById = {}
var complexesById = {}

export default {
  name: 'search',
  props: ['alarm', 'warning', 'maintenance', 'text'],
  components: {
    'dashboard-map': DashboardMap
  },
  data () {
    return {
      filter: {
        normal: true,
        maintenance: true,
        alarm: true,
        warning: true,
        switch: true,
        crossing: true,
        axlecounter: true,
        traindetection: true,
        axleshunt: true,
        mainvoltage: true,
        location: true,
        unknown: true
      },
      searchLoader: false,
      search: '',
      regions: [],
      tab: 'hierarchy',
      numberInError: 0,
      numberInWarning: 0,
      numberInMaintenance: 0,
      lastUpdated: new Date(),
      filteredRailObjects: []
    }
  },
  beforeCreate: function () {
  },
  created: function () {
    if (this.alarm || this.warning || this.maintenance) {
      this.filter.alarm = false
      this.filter.warning = false
      this.filter.maintenance = false
      this.filter.normal = false
    }

    if (this.alarm) {
      this.filter.normal = false
      this.filter.alarm = true
    }

    if (this.warning) {
      this.filter.normal = false
      this.filter.warning = true
    }

    if (this.maintenance) {
      this.filter.alarm = true
      this.filter.warning = true
      this.filter.maintenance = true
      this.filter.normal = true
    }

    this.search = this.text || ''
  },
  mounted: function () {
    this.filterList()
  },
  beforeDestroy: function () {
  },
  watch: {
    'search': {
      handler: function (val, oldVal) {
        this.searchLoader = true
        clearTimeout(searchTimer)
        searchTimer = setTimeout(() => {
          this.searchLoader = false
          this.filterList()
        }, 500)
      }
    },
    'filter': {
      handler: function (val, oldVal) {
        this.filterList()
      },
      deep: true
    }
  },
  methods: {
    complexRailObjectSorted: function (complexRailObjects) {
      return UtilitiesService.railObjectsSorted(complexRailObjects)
    },
    filterList: function () {
      var possObjectCodes = PossObjectCodeService.getPossObjectCodes()
      var possObjectCodesById = {}
      possObjectCodes.forEach((possObjectCode) => {
        possObjectCodesById[possObjectCode.Id] = possObjectCode
      })

      this.numberInError = 0
      this.numberInWarning = 0
      this.numberInMaintenance = 0

      this.filteredRailObjects = []

      var find = (value, search) => {
        let found = true
        value = value.toLowerCase().trim()
        let searchArray = search.split(' ')
        for (let i = 0; i < searchArray.length; i++) {
          let searchValue = searchArray[i]
          if (value.indexOf(searchValue.toLowerCase()) === -1) {
            found = false
            break
          }
        }
        return found
      }

      var inFilter = (railObject) => {
        let filter = true
        // Filter status
        if (!this.filter.normal && railObject.MonitorStatusId === 1) {
          return false
        }
        if (!this.filter.warning && railObject.MonitorStatusId === 2) {
          return false
        }
        if (!this.filter.alarm && railObject.MonitorStatusId === 3) {
          return false
        }
        if (!this.filter.maintenance && railObject.OperationModeId === 5) {
          return false
        }

        if (!this.filter.unknown && railObject.OperationModeId === 1 && railObject.MonitorStatusId !== 1 && railObject.MonitorStatusId !== 2 && railObject.MonitorStatusId !== 3) {
          return false
        }

        // filter type
        if (!this.filter.switch && possObjectCodesById[railObject.PossObjectCodeId] &&
          (possObjectCodesById[railObject.PossObjectCodeId].Code === 'MKW' || possObjectCodesById[railObject.PossObjectCodeId].Code === 'PSI')) {
          return false
        }
        if (!this.filter.crossing && possObjectCodesById[railObject.PossObjectCodeId] && possObjectCodesById[railObject.PossObjectCodeId].Code === 'OV') {
          return false
        }
        if (!this.filter.axlecounter && possObjectCodesById[railObject.PossObjectCodeId] && possObjectCodesById[railObject.PossObjectCodeId].Code === 'AT') {
          return false
        }
        if (!this.filter.traindetection && possObjectCodesById[railObject.PossObjectCodeId] && possObjectCodesById[railObject.PossObjectCodeId].Code === 'TR') {
          return false
        }
        if (!this.filter.axleshunt && possObjectCodesById[railObject.PossObjectCodeId] && possObjectCodesById[railObject.PossObjectCodeId].Code === 'SHUNT') {
          return false
        }
        if (!this.filter.location && possObjectCodesById[railObject.PossObjectCodeId] &&
          (possObjectCodesById[railObject.PossObjectCodeId].Code === 'RT' || possObjectCodesById[railObject.PossObjectCodeId].Code === 'T' || possObjectCodesById[railObject.PossObjectCodeId].Code === 'TI')) {
          return false
        }
        return filter
      }

      var categorize = (railObject, type) => {
        switch (type) {
          case 'error':
            if (railObject.shown) {
              if (railObject.RegionId) {
                regionsById[railObject.RegionId].error.push(railObject)
              }
              if (railObject.DepartmentId) {
                departmentsById[railObject.DepartmentId].error.push(railObject)
              }
              if (railObject.ComplexId) {
                complexesById[railObject.ComplexId].error.push(railObject)
              }
              this.numberInError++
            }
            break
          case 'warning':
            if (railObject.shown) {
              if (railObject.RegionId) {
                regionsById[railObject.RegionId].warning.push(railObject)
              }
              if (railObject.DepartmentId) {
                departmentsById[railObject.DepartmentId].warning.push(railObject)
              }
              if (railObject.ComplexId) {
                complexesById[railObject.ComplexId].warning.push(railObject)
              }
              this.numberInWarning++
            }
            break
          case 'maintenance':
            if (railObject.shown) {
              if (railObject.RegionId) {
                regionsById[railObject.RegionId].maintenance.push(railObject)
              }
              if (railObject.DepartmentId) {
                departmentsById[railObject.DepartmentId].maintenance.push(railObject)
              }
              if (railObject.ComplexId) {
                complexesById[railObject.ComplexId].maintenance.push(railObject)
              }
              this.numberInMaintenance++
            }
            break
          case 'normal':
            if (railObject.RegionId) {
              regionsById[railObject.RegionId].normal.push(railObject)
            }
            if (railObject.DepartmentId) {
              departmentsById[railObject.DepartmentId].normal.push(railObject)
            }
            if (railObject.ComplexId) {
              complexesById[railObject.ComplexId].normal.push(railObject)
            }
            break
          case 'unknown':
            if (railObject.RegionId) {
              regionsById[railObject.RegionId].unknown.push(railObject)
            }
            if (railObject.DepartmentId) {
              departmentsById[railObject.DepartmentId].unknown.push(railObject)
            }
            if (railObject.ComplexId) {
              complexesById[railObject.ComplexId].unknown.push(railObject)
            }
            break
        }
      }
      var regions = JSON.parse(JSON.stringify(RegionService.getRegions()))
      var departments = JSON.parse(JSON.stringify(DepartmentService.getDepartments()))
      var complexes = JSON.parse(JSON.stringify(ComplexService.getComplexes()))
      regions.forEach((region) => {
        regionsById[region.RegionId] = region
        region.error = []
        region.warning = []
        region.maintenance = []
        region.normal = []
        region.unknown = []
        region.Departments = []
        region.open = false
        region.shown = false // this.search === ''
      })
      departments.forEach((department) => {
        departmentsById[department.DepartmentId] = department
        department.error = []
        department.warning = []
        department.maintenance = []
        department.normal = []
        department.unknown = []
        department.Complexes = []
        regionsById[department.RegionId].Departments.push(department)
        department.open = false
        department.shown = false // this.search === ''
      })
      complexes.forEach((complex) => {
        complexesById[complex.ComplexId] = complex
        complex.error = []
        complex.warning = []
        complex.maintenance = []
        complex.unknown = []
        complex.normal = []
        departmentsById[complex.DepartmentId].Complexes.push(complex)
        complex.open = false
        complex.shown = false // this.search === ''
        complex.RailObjects = []
      })

      let tempFilteredRailObjects = []
      RailObjectService.getRailObjects().concat(RailObjectService.getRailObjectChildren())
        .filter(r => r.DataSourceCode === 'WID' || r.DataSourceCode === 'ATD' || r.DataSourceCode === 'CDD' || r.DataSourceCode === 'AKD')
        .forEach((railObject) => {
          if (!inFilter(railObject)) {
            railObject.shown = false
            return
          }

          if (railObject.ParentRailObjectId !== null) {
            if (this.search !== '' && find(railObject.Name, this.search)) {
              departmentsById[railObject.DepartmentId].open = true
              departmentsById[railObject.DepartmentId].shown = true
              regionsById[departmentsById[railObject.DepartmentId].RegionId].open = true
              regionsById[departmentsById[railObject.DepartmentId].RegionId].shown = true
              complexesById[railObject.ComplexId].open = true
              complexesById[railObject.ComplexId].shown = true
              const parentRailObject = complexesById[railObject.ComplexId].RailObjects.find(ro => ro.RailObjectId === railObject.ParentRailObjectId)
              // Only add the components if the parent hasn't been found or if other components have been added already
              if (parentRailObject && (!parentRailObject.shown || parentRailObject.Components.length > 0)) {
                parentRailObject.shown = true
                parentRailObject.Components.push(railObject)
              }
            }
            return
          }

          if (this.search === '' /* && inFilter(railObject) */) {
            railObject.shown = true
            departmentsById[railObject.DepartmentId].shown = true
            regionsById[departmentsById[railObject.DepartmentId].RegionId].shown = true
            complexesById[railObject.ComplexId].shown = true
          } else if (find(railObject.Name + departmentsById[railObject.DepartmentId].Name + regionsById[railObject.RegionId].Name + complexesById[railObject.ComplexId].Name, this.search) && inFilter(railObject)) {
            railObject.shown = true
            departmentsById[railObject.DepartmentId].open = true
            departmentsById[railObject.DepartmentId].shown = true
            regionsById[departmentsById[railObject.DepartmentId].RegionId].open = true
            regionsById[departmentsById[railObject.DepartmentId].RegionId].shown = true
            complexesById[railObject.ComplexId].open = true
            complexesById[railObject.ComplexId].shown = true
          } else {
            railObject.shown = false
          }

          if (railObject.ComplexId) {
            complexesById[railObject.ComplexId].RailObjects = complexesById[railObject.ComplexId].RailObjects || []
            railObject.Components = []
            complexesById[railObject.ComplexId].RailObjects.push(railObject)
          }

          if (railObject.OperationModeId === 5) {
            categorize(railObject, 'maintenance')
          } else {
            switch (railObject.MonitorStatusId) {
              case 1:
                categorize(railObject, 'normal')
                break
              case 2:
                categorize(railObject, 'warning')
                break
              case 3:
                categorize(railObject, 'error')
                break
              default:
                categorize(railObject, 'unknown')
                break
            }
          }

          if (railObject.shown) {
            tempFilteredRailObjects.push(railObject)
          }
        })
      this.regions = UtilitiesService.sortByKey(regions, 'Name')
      this.lastUpdated = new Date()
      this.filteredRailObjects = tempFilteredRailObjects
    },
    showDetail: function (railObject) {
      if (railObject.DataSourceCode === 'WID') {
        Router.push({
          name: 'SwitchMeasurement',
          params: {
            id: railObject.RailObjectId,
            measurementId: railObject.LastMeasurementId
          },
          props: true
        })
      }
      if (railObject.DataSourceCode === 'ATD') {
        Router.push({
          name: 'AxleCounter',
          params: {
            railobjectid: railObject.RailObjectId
            // passedMeasurementId: railObject.LastMeasurementId
          }
        })
      }
      if (railObject.DataSourceCode === 'AKD') {
        Router.push({
          name: 'AxleShunt',
          params: {
            id: railObject.RailObjectId
          }
        })
      }
      if (railObject.DataSourceCode === 'CDD') {
        Router.push({
          name: 'MixedSignals',
          params: {
            railobjectid: railObject.RailObjectId
          },
          props: true
        })
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.filter.alarm = to.query.alarm || false
    this.filter.warning = to.query.warning || false
    this.filter.maintenance = to.query.maintenance || false

    this.search = to.query.text || ''

    this.filterList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.alarm-list-content > .title {
  padding-top: 16px;
  padding-left: 22px;
}

.alarm-list-content .filter-content,
.alarm-list-content .search-content,
.alarm-list-content .tab-content {
  position: relative;
  padding-left: 22px;
  padding-right: 22px;
  width: 100%;
}

.tab-content {
  display: inline-block;
}

.filter-content > .title {
  margin-top: 20px;
  font-size: 14px;
  font-family:Roboto;
  font-weight: 600;
  font-style: normal;
  line-height: normal;
}

.filters tr {
  border-bottom: none;
}

.filters td span {
  color: rgba(0, 0, 0, 0.87);
}

.filters td:first-child {
  color: rgba(0, 0, 0, 0.4);
}

.filters td, filters th {
  padding: 15px 0px;
}

.search tr td:first-child {
  width: 12%;
  font-size: 14px;
  font-family:Roboto;
  font-weight: 600;
  font-style: normal;
}

.search-placeholder {
  height: 44px;
  width: 344px;
  margin-top: 7px;
  margin-bottom: 7px;
  background-color: #fff;
  position: relative;
  padding-left: 10px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.search-placeholder input {
  width: 280px !important;
  position: absolute;
  height: 44px !important;
  margin: 0px !important;
  border-bottom: none !important;
}

.search-placeholder i {
    height: 44px;
    line-height: 44px;
    color: rgba(0, 0, 0, 0.54);
}

.search tr {
  border: none;
}

.tab-content .tab,
.tab-content .info {
  width: 33%;
  position: relative;
  float: left;
  display: block;
  text-align: center;
  padding: 10px 0px;
  color: #56CCF2;
}

.tab-page-fixed {
  height: calc(100vh - 480px);
}

.tab-page {

  position: relative;
  float: left;
  width: 100%;
}

.tab.active::after {
  content: '';
  top: 0px;
  left: 0px;
  position: absolute;
  width:100%;
  height:100%;
  border-bottom: 3px solid #56CCF2;
}

.list-region {
  font-size: 20px;
}

.list-department {
  font-size: 18px;
  margin-left: 20px;
}

.list-complex {
  font-size: 16px;
  margin-left: 40px;
}

.list-railobject {
  font-size: 14px;
  margin-left: 86px;
  color: rgba(0, 0, 0, 0.87);
  list-style-type: disc !important;
}

.list-railobjectComponents {
  font-size: 14px;
  margin-left: 10px;
  color: rgba(0, 0, 0, 0.87);
  list-style-type: '- ' !important;
}

.list-region > .material-icons,
.list-department > .material-icons,
.list-complex > .material-icons {
  top: 4px !important;
  position: relative;
}

.railobject-icon > .material-icons {
  top: 3px;
  font-size: 20px;
  position: relative;
  margin-left:5px;
}

.error-count,
.warning-count,
.maintenance-count,
.total-count,
.railobject-type {
  margin-left: 10px;
}

.total-count {
  line-height: 20px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.railobject-type {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.info span {
  display: inline-block;
}

.info span i {
  float: right;
  margin: 0 5px;
}

.extended-opacity {
  opacity: 0.56;
}

.tab-page > ul {
  margin: 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/Search.vue